import React, { useState } from 'react'
import {
  Notice,
  Icon,
  InfoFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const icon = <Icon color="dark" size="medium" svgComponent={InfoFilled} />

const message = (
  <span>
    Starting June 2nd, payout rates will be based on your sales performance over
    the past 12 months. To learn more about the new payout rates, please{' '}
    <a
      href="https://help.cgtrader.com/hc/en-us/articles/35293756906257-Payout-Rate-System-Explained"
      target="_blank"
      rel="noopener noreferrer"
    >
      click here.
    </a>
  </span>
)

export default function LevelNotice() {
  const [open, setOpen] = useState(true)
  if (!open) return null
  return (
    <Notice
      type="primary"
      useSSRIcon
      ssrIcon={icon}
      className="cgt-mb-20"
      onClose={() => setOpen(false)}
    >
      {message}
    </Notice>
  )
}
